<style lang="scss" scoped></style>

<template>
  <div>
    <nuxt />
  </div>
</template>

<script>
export default {
  head() {
    const i18nSeo = this.$nuxtI18nSeo();
    const script = [
      {
        hid: 'flexiblejs',
        src:
          'https://static-web.likeevideo.com/as/bigo-static/cdn/flexible/flexible.min.js',
        type: 'text/javascript',
        charset: 'utf-8',
        head: true,
        defer: true
      },
      { hid: 'captcha', src: '' },
      { hid: 'videojs', src: '' },
      { hid: 'qrcodejs', src: '' },
      { hid: 'devicevjs', src: '' }
    ];
    return {
      script,
      link: [{ hid: 'videojscss', href: '' }, ...i18nSeo.link],
      meta: [...i18nSeo.meta],
      htmlAttrs: {
        class: ['html-style'],
        ...i18nSeo.htmlAttrs
      },
      bodyAttrs: {
        class: ['body-style']
      }
    };
  }
};
</script>
<style lang="scss">
@import '@assets/scss/mobile.scss';
</style>
